import { combineReducers } from 'redux';
import { TOGGLE_EDIT_MODE } from '../actions/ui';

const isEditMode = (state = false, { type }) => {
    const newState = state;

    if (type === TOGGLE_EDIT_MODE) {
        return !state;
    }

    return newState;
};

export default combineReducers({
    isEditMode,
});
